import DashedIcon from '../../../../assets/icons/dashed.svg';
import CalendarIcon from '../../../../assets/icons/calendar.svg';
import ChronometerIcon from '../../../../assets/icons/ChronoMeter.svg';
import QuestionIcon from '../../../../assets/icons/QuestionMark.svg';
import Moment from "moment";
import { useNavigate } from 'react-router-dom';
import SharedService from '../../../../services/SharedService';

const MasterQuizCard = ({ no, data }) => {
    const navigate = useNavigate();

    const minutesToTime = (minutes) => {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
    }
 const handleOpenAssessment = (data) => {
 sessionStorage.setItem("quizId", data.id);
 navigate(`/masters-quizzes/${SharedService.GenerateSlug(data.quizName)}`, { state: { id: data.id } })
 };
    return (
        <div className="card border-0 shadow p-3 p-lg-4 h-100"
            style={{ minHeight: "100px" }}
        >
            <div className="text-center  w-100 mb-2 fw-bold">Quiz {no + 1}</div>
            <div className="text-center fw-light  w-100 mb-3" style={{ minHeight: "48px" }}>{data.quizName}</div>
            <div className="progress " style={{ "height": "6px" }}>
                <div className="progress-bar bg-success" role="progressbar" style={{ "width": `${data.attendeePercent}%` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div className="d-flex justify-content-start mb-3 fw-light">
                <div>
                    {data.totalAttendees}/{data.totalUsers}
                </div>
            </div>
            <div className="d-flex justify-content-between mb-4">
                <div className='fw-light' title='No of Users'>
                    <img
                        src={DashedIcon}
                        alt="No of Users"
                        className="hover:opacity-70 me-1 mb-1"
                    /> {data.totalUsers}
                </div>
              <div className="fw-light" title='Scheduled On'>
              <img
             src={CalendarIcon}
             alt="Date"
             className="w-4 h-4 hover:opacity-70 me-1 mb-1"
             /> 
            {data.scheduledDate
             ? Moment(data.scheduledDate).isValid()
            ? Moment(data.scheduledDate).format("DD/MM/YYYY")
               : "-"
             : "-"}
         </div>
            </div>
            <div className="d-flex justify-content-between mb-4">
                <div className='fw-light' title='No of Questions'>
                    <img
                        src={QuestionIcon}
                        alt="No of Questions"
                        className="hover:opacity-70 me-1 mb-2"
                    /> {data.totalMCQQuestions}
                </div>
                <div className='fw-light' title='Duration'>
                    <img
                        src={ChronometerIcon}
                        alt="Duration"
                        className="hover:opacity-70 me-1 mb-1"
                    /> {minutesToTime(data.quizTimeInMinutes)}
                </div>
            </div>
            <div className="d-flex justify-content-center mb-1">
                <button
                    className="px-5 py-2 rounded-pill w-100 btn btn-outline"
                 onClick={() => handleOpenAssessment(data)}
                >
                    Open
                </button>
            </div>
        </div >
    );
}

export default MasterQuizCard